import { combineReducers } from 'redux';
import { jobMappingReducer } from './job';
import { levelMappingReducer } from './level';

export const mappingReducer = combineReducers({
  job: jobMappingReducer,
  level: levelMappingReducer,
});
